export enum ScheduleType {
    Continuous,
    DayOfWeek,
    CustomDays,
    None
  }
  